<template>
  <div class="tebodyitem">
    <div class="tebodyitem-header"><span>配置内容</span></div>
  </div>
  <div class="tebodyitem">
    <el-form-item label="邮箱IMAP服务器" required>
      <el-input v-model="form.host" clearable placeholder="请输入" />
    </el-form-item>
    <el-form-item label="邮箱账号" required>
      <el-input v-model="form.username" clearable placeholder="请输入" />
    </el-form-item>
    <el-form-item label="邮箱授权码" required>
      <el-input v-model="form.password" clearable placeholder="请输入" />
    </el-form-item>
  </div>
  <div class="tebodyitem full">
    <el-form-item label="结果文件信息（勾选后，该字段信息将会记录在结果表格中）" required>
      <el-checkbox-group v-model="form.fields">
        <el-row style="width: 100%;">
          <el-col :span="6" v-for="(item, index) in fields">
            <el-checkbox :label="item?.fieldDesc" :value="item?.fieldName" />
          </el-col>
        </el-row>
      </el-checkbox-group>
    </el-form-item>
  </div>
  <!-- <MoreSetting>
    <div class="tebodyitem full">
      <el-form-item label="pod是否只需五字码" required>
        <div style="display: flex; align-items: center;width: 100%;">
          <el-radio-group v-model="form.pod">
            <el-radio :value="false" size="large">不需要</el-radio>
            <el-radio :value="true" size="large">需要</el-radio>
          </el-radio-group>
        </div>
      </el-form-item>
    </div>
  </MoreSetting> -->
</template>

<script setup>
  import {onMounted, ref, watch} from 'vue';
  import { Close, Search, Minus, ArrowDown, CirclePlus, RemoveFilled, CirclePlusFilled } from '@element-plus/icons-vue'
  import * as Request from '@/assets/request';
  import MoreSetting from '../moresetting/index';

  const emits = defineEmits([ 'change' ])

  const props = defineProps({
    data: {
      type: Object,
      default: null
    }
  });

  const form = ref({})
  watch(() => form.value, () => {
    emits('change', form.value)
  }, { deep: true });

  const fields = ref([])
  const init = () => {
    console.log('props.data---', props.data);
    form.value.host = props.data?.host;
    form.value.username = props.data?.username;
    form.value.password = props.data?.password;
    fields.value = props.data?.fields;
    fields.value.map(item => {
      if(item.checked == 2) {
        form.value.fields = form.value.fields || []
        form.value.fields.push(item.fieldName);
      }
    })
  }
  watch(() => props.data, () => {
    init();
  }, { deep: true });

  const fieldsList = ref([])
  const getInitData = async () => {
    const result = await Request.post({
      url: `/22001/facade/commons/params/template/getBcParseParams`,
      data: {
        id: null
      }
    })
    if(result?.code != 200) return;
    // form.value = result?.data;

    const _fieldsList = []
    const _formFieldsList = []
    if(result?.data?.fields?.length > 0) {
      result.data.fields.map(item => {
        _fieldsList.push(item?.fieldName);
        if(item.checked == 2) {
          _formFieldsList.push(item?.fieldName);
        }
      })
    }
    fieldsList.value = _fieldsList;
    form.value.fields = _formFieldsList;
  }
  onMounted(() => {
    getInitData()
  })
</script>

<style scoped lang="less">
  @import "./index.less";
</style>